import { createSlice } from "@reduxjs/toolkit";

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    projects: [],
    folders: {},
    files: {},
    sentences: [],
    selectedProjectId: null,
    selectedFolderId: null,
    selectedFileId: null,
    selectedTargetId: null,
    selectedTargetName: null,
    completedProjects: [],
    completedFolders: [],
    completedFiles: [],
    manageUsers: [],
    assignedLanguages: [],
    activetab: 'GA',
    notifications: [],
    unreadCount: 0,
    totalProjects: null,
    totalFiles: null,
    totalSentences: null,
    targetLang: null,
    createdFor: null
  },
  reducers: {
    addProjects: (state, action) => {
      state.projects = action.payload;
    },
    addFolders: (state, action) => {
      state.folders = {
        ...state.folders,
        [state.selectedProjectId]: action.payload,
      };
    },
    addFiles: (state, action) => {
      state.files = {
        ...state.files,
        [state.selectedFolderId]: action.payload,
      };
    },
    addSentences: (state, action) => {
      state.sentences = action.payload;
    },
    clearSentences: (state) => {
      state.sentences = [];
    },
    setSelectedProjectId: (state, action) => {
      state.selectedProjectId = action.payload;
    },
    setSelectedFolderId: (state, action) => {
      state.selectedFolderId = action.payload;
    },
    addAssignedLanguages: (state, action) => {
      state.assignedLanguages = action.payload;
    },
    setSeletedFileId: (state, action) => {
      state.selectedFileId = action.payload;
    },
    setSelectedTargetId: (state, action) => {
      state.selectedTargetId = action.payload;
    },
    setSelectedTargetName: (state, action) => {
      state.selectedTargetName = action.payload;
    },
    addManageUsers: (state, action) => {
      state.manageUsers = action.payload;
    },
    addActiveTab: (state, action) => {
      state.activetab = action.payload;
    },
    resetDashboardState: (state) => {
      state.projects = [];
      state.folders = {};
      state.files = {};
      state.selectedProjectId = null;
      state.selectedFolderId = null;
      state.selectedFileId = null;
    },
    refreshFiles: (state, action) => {
      const folderId = action.payload;
      if (folderId && state.files[folderId]) {
        state.files = {
          ...state.files,
          [folderId]: []
        };
      }
    },
    setCompletedProjects: (state, action) => {
      state.completedProjects = action.payload;
    },
    setCompletedFolders: (state, action) => {
      state.completedFolders = action.payload;
    },
    setCompletedFiles: (state, action) => {
      state.completedFiles = action.payload;
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
    setTotalProjects: (state, action) => {
      state.totalProjects = action.payload;
    },
    setTotalFiles: (state, action) => {
      state.totalFiles = action.payload;
    },
    setTotalSentences: (state, action) => {
      state.totalSentences = action.payload;
    },
    setTargetLang: (state, action) => {
      state.targetLang = action.payload;
    },
    setCreatedFor: (state, action) => {
      state.createdFor = action.payload;
    }
  },
});

export const {
  addProjects,
  addFolders,
  addFiles,
  addSentences,
  clearSentences,
  setSelectedFolderId,
  setSelectedProjectId,
  setSeletedFileId,
  addManageUsers,
  setCompletedFiles,
  setCompletedProjects,
  addActiveTab,
  resetDashboardState,
  refreshFiles,
  setSelectedTargetId,
  setSelectedTargetName,
  setNotifications,
  setUnreadCount,
  setTotalProjects,
  setTotalFiles,
  setTotalSentences,
  setTargetLang,
  setCompletedFolders,
  setCreatedFor,
  addAssignedLanguages
} = dashboardSlice.actions;
export default dashboardSlice.reducer;